import React from 'react';
/*
 * `react-dom/client`, nie `react-dom`.
 *
 * React 18 montuje aplikacje przez `createRoot`. Stare `ReactDOM.render`
 * nadal dziala, ale wypisuje ostrzezenie i NIE WLACZA nowosci osiemnastki —
 * przede wszystkim automatycznego grupowania odswiezen. W React 19 znika.
 */
import { createRoot } from 'react-dom/client';
/*
 * `react-helmet-async` trzyma tytuly stron w kontekscie reactowym
 * i BEZ DOSTAWCY rzuca wyjatek. Dostawca musi byc nad calym drzewem —
 * stad tutaj, a nie w ktorymkolwiek ekranie.
 */
import { HelmetProvider } from 'react-helmet-async';
/*
 * STYLE Z node_modules.
 *
 * Byly w src/index.scss z tylda: `@import '~antd/dist/antd.min.css'`.
 * Tylda to skladnia webpacka, ktorej Vite nie zna - ale samo jej
 * usuniecie nie wystarcza: Sass traktuje `@import 'cos.css'` jako zwykly
 * import CSS i zostawia go jako `@import url(...)` zamiast wkleic tresc.
 *
 * KOLEJNOSC JEST ZACHOWANA CO DO JEDNEJ LINII wzgledem oryginalu, bo
 * w CSS wygrywa regula pozniejsza - przestawienie zmienialoby wyglad.
 */
import 'bootstrap-css-only/css/bootstrap.min.css';
/*
 * antd 5 NIE MA pliku ze stylami. Generuje je z JS (CSS-in-JS), wiec
 * `antd/dist/antd.min.css` przestal istniec. Zostal `reset.css` - sama
 * normalizacja przegladarki, ktora antd zaleca wciagnac recznie.
 *
 * MIEJSCE W KOLEJNOSCI BEZ ZMIAN, bo w CSS wygrywa regula pozniejsza
 * i przestawienie zmienialoby wyglad.
 */
import 'antd/dist/reset.css';
import './index.scss';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import * as serviceWorker from './serviceWorker';
import './i18n';
import axios from 'axios';
import { baseUrlApi } from "./config/config";
import { ConfigProvider } from 'antd';
// import en_US from 'antd/es/locale/en_US'
import pl_PL from 'antd/es/locale/pl_PL'

/*
 * JEZYK POLSKI DLA DAYJS - USTAWIANY RAZ, TUTAJ.
 *
 * RoZNICA WZGLEDEM MOMENT, ktora latwo przeoczyc: w moment sam import
 * `moment/locale/pl` WLACZAL ten jezyk. W dayjs import tylko go REJESTRUJE -
 * zeby go wlaczyc, trzeba wywolac `dayjs.locale('pl')`.
 *
 * Bez tej linii daty formatowalyby sie po angielsku (nazwy miesiecy, dni
 * tygodnia, pierwszy dzien tygodnia w kalendarzu) - i nikt by nie zglosil
 * bledu, bo aplikacja dziala, tylko mowi w zlym jezyku.
 *
 * Wczesniej import jezyka byl powtorzony w 10 plikach. Zostaje tam, bo
 * rejestracja jest nieszkodliwa, ale WLACZENIE jest jedno i jest tutaj.
 */
import dayjs from 'dayjs';
import 'dayjs/locale/pl';
dayjs.locale('pl');

// Redux
import history from './config/historia';
import { ustawSklep } from './redux/sklep';
import { createStore, applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux';
import createSagaMiddleware from 'redux-saga';
import reducers from './redux/reducers';
import sagas from './redux/sagas';
import Router from './router';
import actions from "./redux/user/actions";
import {validateLocalStorage, validateSessionStorage} from "./utils/utils";
import {ROUTE_FORGOT_PASSWORD, ROUTE_REGISTER, ROUTE_RESET_PASSWORD} from "./config/routes";
// Pomiar czasu zadan do API. Import musi byc PRZED pierwszym zadaniem,
// zeby przechwytywacz zdazyl sie zarejestrowac. Poza produkcja nie robi nic.
import "./utils/pomiarZadan";

// middlewaredy
const sagaMiddleware = createSagaMiddleware();
// Bylo tu jeszcze `routerMiddleware` z `connected-react-router`. Ta paczka
// nie wspiera routera 6, a jej jedyne zadanie — trzymanie adresu w reduxie —
// bylo w tym projekcie nieuzywane.
const middlewares = [sagaMiddleware];
const store = createStore(reducers(history), compose(applyMiddleware(...middlewares)));

// Musi byc PRZED uruchomieniem sag: settings/sagas siega po sklep
// z funkcji zwrotnych podpietych przy starcie.
ustawSklep(store);

sagaMiddleware.run(sagas);

if(validateLocalStorage("access_token")){
    // @ts-ignore
    sessionStorage.setItem("access_token", localStorage.getItem("access_token"))
}

if(validateLocalStorage("superAdmin")){
    // @ts-ignore
    sessionStorage.setItem("superAdmin", localStorage.getItem("superAdmin"))
}

if(validateLocalStorage("subscriber")){
    // @ts-ignore
    sessionStorage.setItem("subscriber", localStorage.getItem("subscriber"))
}

if(validateLocalStorage("superAdminWorkspace")){
    // @ts-ignore
    sessionStorage.setItem("superAdminWorkspace", localStorage.getItem("superAdminWorkspace"))
}

// Axios
axios.defaults.baseURL = baseUrlApi;
if (validateSessionStorage("access_token")) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${sessionStorage.getItem('access_token')}`;
} else if (validateLocalStorage("access_token")) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
}
axios.interceptors.response.use(undefined, (error) => {
    /*
     * Status czytamy NAJPIERW z `error.response`, dopiero potem z `error.request`.
     *
     * Wczesniej bylo tylko `error.request.status`. Dziala to w przegladarce,
     * bo adapter XHR wklada tam `XMLHttpRequest`, ktory ma pole `status` —
     * ale to szczegol implementacyjny adaptera, nie czesc API axiosa.
     * Sprawdzone na axios 1.20 pod Node (adapter http): `request.status` jest
     * tam `undefined`, a `response.status` ma poprawne 401.
     *
     * `error.response.status` to droga opisana w dokumentacji i jedyna, ktora
     * zachowuje sie tak samo niezaleznie od adaptera. Stary warunek zostaje
     * jako zapasowy, zeby nie zepsuc sciezki, ktora dzis dziala.
     */
    const status = (error.response && error.response.status)
        || (error.request && error.request.status);

    if (status === 401) {

        /** "If" operator handles unwanted redirects to login page **/
        if (window.location.pathname === ROUTE_FORGOT_PASSWORD ||
            window.location.pathname === ROUTE_RESET_PASSWORD ||
            window.location.pathname.includes(ROUTE_REGISTER().substr(0, ROUTE_REGISTER().length-4))
        ) return ;
        store.dispatch({
            type: actions.LOCAL_LOGOUT
        });
    }
    return Promise.reject(error);
});

const korzen = document.getElementById('root');
if (!korzen) throw new Error('Brak elementu #root — nie ma gdzie zamontowac aplikacji.');

createRoot(korzen).render(
    <HelmetProvider>
        <Provider store={store}>
            <ConfigProvider locale={pl_PL}>
                <Router history={history} />
            </ConfigProvider>
        </Provider>
    </HelmetProvider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

// CELOWO NIC STAD NIE EKSPORTUJEMY. `history` mieszka w
// src/config/historia.ts, a dostep do sklepu daje src/redux/sklep.ts.
// Import z punktu wejscia tworzyl cykl index -> router -> ekrany -> index.
